import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { bool, params, shape, string, useDataModel } from '@thd-nucleus/data-sources';
import { Typography } from '@one-thd/sui-atomic-components';

export const ProductSponsored = ({ position, itemId, noBackground, noPadding }) => {
  const { data } = useDataModel('product', {
    variables: {
      itemId,
    },
  });

  const [sponsoredValues, setSponsoredValues] = useState({});
  const { info } = data?.product || {};
  const sponsoredWrapperClass = noPadding ? '' : 'sui-pl-1';
  const colorClass = noBackground ? 'subtle' : '';
  const backgroundColor = noBackground ? '' : 'sui-bg-strong sui-px-1';
  const fontWeight = noBackground ? '' : 'bold';

  useEffect(() => {
    if (info) {
      setSponsoredValues({
        isSponsored: sponsoredValues?.isSponsored || info?.isSponsored,
        sponsoredBeacon: sponsoredValues?.sponsoredBeacon || info?.sponsoredBeacon,
        sponsoredMetadata: sponsoredValues?.sponsoredMetadata || info?.sponsoredMetadata
      });
    }
  }, [info?.isSponsored, info?.sponsoredBeacon, info?.sponsoredMetadata]);

  if (!data?.product) return null;
  const { isSponsored, sponsoredBeacon } = sponsoredValues;

  if (!isSponsored) return null;

  return (
    <div className={sponsoredWrapperClass}>
      <div
        className={`${backgroundColor}`}
        id={'plp_pod_sponsored_' + position}
        data-onview-beacon={sponsoredBeacon?.onViewBeacon}
        data-onclick-beacon={sponsoredBeacon?.onClickBeacon}
      >
        <Typography variant="body-xs" color={colorClass} weight={fontWeight} >Sponsored</Typography>
      </div>
    </div>
  );
};

ProductSponsored.propTypes = {
  position: PropTypes.number.isRequired,
  itemId: PropTypes.string.isRequired,
  noBackground: PropTypes.bool,
  noPadding: PropTypes.bool,
};

ProductSponsored.defaultProps = {
  noBackground: false,
  noPadding: false
};

ProductSponsored.dataModel = {
  product: params({
    itemId: string().isRequired(),
  }).shape({
    itemId: string(),
    dataSources: string(),
    info: shape({
      isSponsored: bool(),
      sponsoredBeacon: shape({
        onClickBeacon: string(),
        onViewBeacon: string()
      }),
      sponsoredMetadata: shape({
        campaignId: string(),
        placementId: string(),
        slotId: string()
      }),
    }),
  }),
};

ProductSponsored.displayName = 'ProductSponsored';
